import React from "react";
import * as Sentry from "@sentry/node";
import { GenericErrorPage } from "pages/error";
import { getErrorMessage } from "utils/error";
import DefaultThemeProvider from "components/Layout/DefaultThemeProvider";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(getErrorMessage(error));
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  render() {
    if (this.state.hasError) {
      // The crashed subtree (including _app.js's own DefaultThemeProvider)
      // has been unmounted, so GenericErrorPage needs its own theme context
      // — without it, its styled components that read theme.colors/theme.media
      // (e.g. via StickyHeaderLayout) would throw on an undefined theme.
      return (
        <DefaultThemeProvider>
          <GenericErrorPage label="Something went wrong on our end." />
        </DefaultThemeProvider>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
